// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ShippingCostBar-module__wrapper{margin-bottom:1rem}.ShippingCostBar-module__progress-bar{margin-bottom:1rem}", "",{"version":3,"sources":["webpack://./src/components/cart/ShippingCostBar/ShippingCostBar.module.scss"],"names":[],"mappings":"AAAA,iCACE,kBAAA,CAGF,sCACE,kBAAA","sourcesContent":[".wrapper {\n  margin-bottom: 1rem;\n}\n\n.progress-bar {\n  margin-bottom: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": "ShippingCostBar-module__wrapper",
	"progress-bar": "ShippingCostBar-module__progress-bar",
	"progressBar": "ShippingCostBar-module__progress-bar"
};
export default ___CSS_LOADER_EXPORT___;
